// extracted by mini-css-extract-plugin
export default {"root":"CustomSections__root--wWpKF","add-section":"CustomSections__add-section--oMQTP","addSection":"CustomSections__add-section--oMQTP"};